<!-- School projects - 科研经历 -->
<template>
  <div>
    <h1>School projects</h1>
    <div class="dis-96" v-for="(item,index) in info.scientificResearchProject" :key="index">
      <h2>School projects 0{{index + 1}}</h2>
      <ul class="ul-item dis-40">
        <li>
          <div>Name and context</div>
          <div>{{item.name}}</div>
        </li>
        <li>
          <div>Date</div>
          <div>{{item.projectDate}}</div>
        </li>
      </ul>
      <div class="dis-40">
        <div class="dis-12">People involved (make sure to include title)</div>
        <div>{{item.participants}}</div>
      </div>
      <div class="dis-24">
        <div class="dis-12">Description</div>
        <div>
          <pre>{{item.description}}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { infoQueryScientific } from '@/api/mentee'
export default {
  name: 'mentee-info-school',
  components: {},
  data () {
    return {
      info: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      let param = {
        num: this.$route.params.id
      }
      infoQueryScientific(param).then(res => {
        let data = res.data.model || {}
        this.info = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
